/* ============================================
   APP JAVASCRIPT
   ============================================ */

(function () {
    'use strict';

    // Dedicated modules (callback-form.js, callback-modal.js, cookie-consent.js)
    // own callback/form runtime behavior.

    function initCookieModal() {
    const cookieModal = document.getElementById('cookie-modal');
    const closeBtn = document.querySelector('.cookie-modal__close');
    const toggleSettingsBtn = document.getElementById('toggle-cookie-settings');
    const settingsPanel = document.getElementById('cookie-settings');

    if (!cookieModal) return;

    if (!hasCookieConsent()) {
        setTimeout(() => {
            showCookieModal();
        }, 1000);
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', hideCookieModal);
    }

    cookieModal.addEventListener('click', function (e) {
        if (e.target === cookieModal || e.target.classList.contains('cookie-modal__backdrop')) {
            hideCookieModal();
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && cookieModal.classList.contains('cookie-modal--show')) {
            hideCookieModal();
        }
    });

    if (toggleSettingsBtn && settingsPanel) {
        toggleSettingsBtn.addEventListener('click', function () {
            const isHidden = settingsPanel.style.display === 'none' || !settingsPanel.style.display;
            settingsPanel.style.display = isHidden ? 'block' : 'none';
            toggleSettingsBtn.innerHTML = isHidden
                ? '<i class="fas fa-times me-2"></i>Скрыть настройки'
                : '<i class="fas fa-cog me-2"></i>Настройки';
        });
    }

    const acceptAllBtn = document.querySelector('.cookie-modal__accept-all');
    const rejectAllBtn = document.querySelector('.cookie-modal__reject-all');
    const saveSettingsBtn = document.querySelector('.cookie-modal__save-settings');

    if (acceptAllBtn) {
        acceptAllBtn.addEventListener('click', function () {
            acceptAllCookies();
        });
    }

    if (rejectAllBtn) {
        rejectAllBtn.addEventListener('click', function () {
            rejectAllCookies();
        });
    }

    if (saveSettingsBtn) {
        saveSettingsBtn.addEventListener('click', function () {
            saveCookieSettings();
        });
    }
}

    function hasCookieConsent() {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [name] = cookie.trim().split('=');
            if (name === 'cookie-consent') {
                return true;
            }
        }
        return false;
    }

    function showCookieModal() {
        const cookieModal = document.getElementById('cookie-modal');
        if (cookieModal) {
            cookieModal.classList.add('cookie-modal--show');
            document.body.style.overflow = 'hidden';
        }
    }

    function hideCookieModal() {
        const cookieModal = document.getElementById('cookie-modal');
        if (cookieModal) {
            cookieModal.classList.remove('cookie-modal--show');
            document.body.style.overflow = '';
        }
    }

    async function recordCookieConsent(type, isGranted, consentScope) {
        try {
            await fetch('/api/consent/record', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]')?.value || ''
                },
                body: JSON.stringify({
                    type: type,
                    isGranted: isGranted,
                    consentScope: consentScope,
                    policyVersion: 'cookies-v1.3'
                })
            });
        } catch (error) {
            // Intentionally non-blocking: local consent still applied.
        }
    }

    async function acceptAllCookies() {
        document.cookie = 'cookie-consent=all; path=/; max-age=31536000; SameSite=Lax';
        await Promise.all([
            recordCookieConsent('technical', true, 'essential'),
            recordCookieConsent('analytics', true, 'analytics'),
            recordCookieConsent('marketing', true, 'marketing')
        ]);
        window.showAlert('Все файлы cookie приняты', 'success');
        hideCookieModal();
    }

    async function acceptEssentialCookies() {
        document.cookie = 'cookie-consent=essential; path=/; max-age=31536000; SameSite=Lax';
        await Promise.all([
            recordCookieConsent('technical', true, 'essential'),
            recordCookieConsent('analytics', false, 'analytics'),
            recordCookieConsent('marketing', false, 'marketing')
        ]);
        window.showAlert('Приняты только необходимые файлы cookie', 'info');
        hideCookieModal();
    }

    // Alias: reject all = accept only essential
    const rejectAllCookies = acceptEssentialCookies;

    async function saveCookieSettings() {
        const checkboxes = document.querySelectorAll('.cookie-modal__category-checkbox:not(:disabled)');
        const acceptedCategories = [];

        checkboxes.forEach(checkbox => {
            if (checkbox.checked) {
                acceptedCategories.push(checkbox.value);
            }
        });

        const consentValue = acceptedCategories.length > 0 ? acceptedCategories.join(',') : 'essential';
        document.cookie = `cookie-consent=${consentValue}; path=/; max-age=31536000; SameSite=Lax`;

        const acceptedSet = new Set(acceptedCategories.map(x => String(x).toLowerCase()));
        await Promise.all([
            recordCookieConsent('technical', true, 'essential'),
            recordCookieConsent('analytics', acceptedSet.has('analytics'), 'analytics'),
            recordCookieConsent('marketing', acceptedSet.has('marketing'), 'marketing')
        ]);

        window.showAlert('Настройки файлов cookie сохранены', 'success');
        hideCookieModal();
    }

    // Public API
    globalThis.initCookieModal = initCookieModal;
    globalThis.acceptAllCookies = acceptAllCookies;
    globalThis.acceptEssentialCookies = acceptEssentialCookies;
    globalThis.rejectAllCookies = rejectAllCookies;
    globalThis.saveCookieSettings = saveCookieSettings;

    // Delegated handler for data-action buttons
    document.addEventListener('click', function (e) {
        const actionBtn = e.target.closest('[data-action]');
        if (!actionBtn) return;

        const action = actionBtn.getAttribute('data-action');
        switch (action) {
            case 'back':
                history.back();
                break;
            case 'reload':
                location.reload();
                break;
        }
    });
})();
